import {AfterContentInit, Component, Directive, Injector, OnInit, Optional} from '@angular/core';

import { IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import { FormComponent } from "../form.component";
import { get } from "lodash-es";
import {CommonModule} from "@angular/common";

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-form-action',
  hostClass: ''
};

@Component({
  selector: 'div[wmFormAction]',
  template: `<ng-container *ngTemplateOutlet="buttonDef?.widgetType === 'button' ? buttonRef : anchorRef; context: { $implicit: buttonDef }"></ng-container>
  <ng-template #buttonRef>
    <button name="{{buttonDef?.key}}" [attr.data-evaluated-caption]="buttonDef?.displayName.startsWith('bind:')" [attr.disabled]="buttonDef?.disabled.toString() === 'true' ? true : null"
            class="btn app-button {{buttonDef?.class}}"  [hidden]="!((form?.updateMode ? buttonDef?.updateMode : !buttonDef?.updateMode) && buttonDef?.show.toString() === 'true')">
      <i class="app-icon {{buttonDef?.iconclass}}"></i>
      <span class="btn-caption">{{buttonDef?.displayName.startsWith('bind:') ? buttonDef?.name : buttonDef?.displayName}}</span>
    </button>
  </ng-template>
  <ng-template #anchorRef>
    <a name="{{buttonDef?.key}}" [attr.disabled]="buttonDef?.disabled.toString() === 'true' ? true : null" class="app-anchor {{buttonDef?.class}}" >
      <i class="app-icon {{buttonDef?.iconclass}}"></i>
      <span class="anchor-caption">{{buttonDef?.displayName.startsWith('bind:') ? buttonDef?.name : buttonDef?.displayName}}</span>
    </a>
  </ng-template>`,
  providers: [
  provideAsWidgetRef(FormActionDirective)
  ],
  imports: [CommonModule],
  standalone: true,
  exportAs: 'wmFormAction'
})
export class FormActionDirective extends StylableComponent implements AfterContentInit {
  static initializeProps = register('wm-form-action');
  accessroles: any;
  action: any;
  binding: any;
  class: string;
  disabled: string | boolean;
  displayName: string;
  iconclass: string;
  iconname: string;
  key: string;
  position: string
  shortcutkey: string;
  show: string | boolean
  tabindex: number;
  title: string;
  type: string;
  updateMode: boolean;
  buttonDef: any;
  hyperlink: string;
  target: string;

  private _propsInitialized: boolean;
  private binddisplayName: string;
  private binddisabled: string;
  private bindtitle: string;
  private bindshow: string;
  private bindclass: string;
  constructor(inj: Injector, @Optional() viewParent: Parent, @Optional() public form: FormComponent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  populateAction() {
    let attrs = this.$attrs;
    this.buttonDef = {
      key: attrs.get('key') || attrs.get('binding'),
      name: attrs.get('name') || attrs.get('key'),
      displayName: this.binddisplayName || attrs.get('display-name') || attrs.get('label') || attrs.get('caption') || this.form.getBindedVal('display-name', this.nativeElement) || '',
      show: this.bindshow || (attrs.get('show') === undefined ? 'true' : (attrs.get('show') || 'false')),
      class: this.bindclass || attrs.get('class') || '',
      conditionalclass: attrs.get('conditionalclass'),
      conditionalstyle: attrs.get('conditionalstyle'),
      iconclass: attrs.get('iconclass'),
      title: this.bindtitle || (attrs.get('title') === undefined ? (attrs.get('display-name') || '') : attrs.get('title')),
      action: attrs.get('action'),
      accessroles: attrs.get('accessroles'),
      shortcutkey: attrs.get('shortcutkey'),
      disabled: this.binddisabled || attrs.get('disabled') || 'false',
      tabindex: attrs.get('tabindex') || undefined,
      widgetType: attrs.get('widget-type') || 'button',
      type: attrs.get('type'),
      hyperlink: attrs.get('hyperlink') || get(this, 'bindhyperlink'),
      target: attrs.get('target'),
      position: attrs.get('position') || 'footer',
      updateMode: attrs.get('update-mode') === undefined ? true : (attrs.get('update-mode')?.toString() === 'true' ? true : false)
    }
    this._propsInitialized = true;
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  ngAfterContentInit() {
    this.populateAction();
    setTimeout(() => {
      this.form.registerActions(this.buttonDef);
      let $formEl =  (this.form as any).formEl||this.form.$element;
      let position = this.nativeElement.getAttribute('position') || 'footer';
      const el = $(this.nativeElement);
      if (position?.includes('header')) {
        $formEl.find('.basic-btn-grp.form-action').first().append(el);
      }
      if (position?.includes('footer')) {
        if (position?.includes('header')) {
          const copyEl = el.clone();
          $formEl.find('.basic-btn-grp.form-action.panel-footer').append(copyEl);
          return;
        }
        $formEl.find('.basic-btn-grp.form-action.panel-footer').append(el);
      }
    });
  }

  override onPropertyChange(key: string, nv: any, ov: any) {
    if (!this._propsInitialized) {
      return;
    }
    if (key === 'display-name') {
      this.buttonDef.displayName = nv;
    }
    this.buttonDef[key] = nv;
  }
}

